export enum DIALOG_TYPES {
  PRIVACY_POLICY = "PRIVACY_POLICY",
  TERMS_AND_CONDITIONS = "TERMS_AND_CONDITIONS",
  GET_STARTED_TIPS = "GET_STARTED_TIPS",
}
